export const AddressColumns = [
    "SNo",
    "Destination",
    'DeliveryCode', 
    'DeliveryAddress',
    'BuyerCode', 
    'BuyerAddress',

  
]